import React, { useRef, useEffect, useContext, useState } from "react";
import KeyboardEventHandler from "react-keyboard-event-handler";

import { Box, makeStyles, Typography } from "@material-ui/core";

import {
  DialogoConfirmacao,
  DialogoDeletarComSenha,
  DialogoSenha,
  LabelCaixa,
  LabelSubtotal,
  LabelTeclasAtalho,
  LabelTotalParcelas,
  Tabela,
  DialogoConsultorPrecos,
  DialogoVerQRCode,
} from "../../../../components";
import LabelTotalParcelasAVista from "../../../../components/Labels/LabelTotalParcelasAVista";
import { useParcelas } from "../../../../hooks";
import { api, imprimirComprovanteTef } from "../../../../services";
import {
  formatCPF,
  formatCNPJ,
  toStringParcela,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  ATALHO_AVANCAR,
  ATALHO_VOLTAR,
  PRIMARY_COLOR_OFFLINE,
  SECONDARY_COLOR_OFFLINE,
  IS_IMPRIMIR_COMPROVANTE_TEF_POS_REGISTRO_TRANSACAO,
  formatTelefone,
  TIPO_OFERTA_PRODUTO_LIBERACAO,
} from "../../../../utils";
import { calcularPontosFidelidade } from "../../../../utils/fidelidade";
import { VendaContext } from "../../context";
import FormParcela from "./Form";
import { AppContext } from "../../../../app/context";
import DialogoDeletarItem from "../../../../components/Dialogos/DialogoDeletarItem";
import DialogoAutorizacaoComQrcode from "../../../../components/Dialogos/DialogoAutorizacao";
import DialogoAutorizacaoQrcode2 from "../../../../components/Dialogos/DialogoAutorizacao2";
import DialogoCarregarCreditoDevolucao from "./DialogoCarregarCreditoDevolucao";
import DialogoComunicacaoSitef from "./DialogoComunicacaoSitef";
import DialogoStatusImpressao from './DialogoComunicacaoSitef/DialogoStatusImpressao'
import DialogoResetarPagamentos from "../../../../components/Dialogos/DialogoResetarPagamentos";

const useStyles = makeStyles((theme) => ({
  "@keyframes fadeIn": {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  textField: {},
  btnImprimir: {
    backgroundColor: theme.palette.secondary.main,
    opacity: 0.4,
  },
  header: {
    height: "22%",
  },
  body: {
    height: "78%",
  },
  footer: {
    height: "15vh",
    padding: "10px",
    paddingBottom: "20px",
  },
  textOverflow: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const VOLTAR_ACTION = ATALHO_VOLTAR;
const FINALIZAR_ACTION = ATALHO_AVANCAR;
const DELETAR_ITEM_ACTION = "F2";
const CONSULTOR_PRECOS_ACTION = "F3";

const VENDA_EM_PARTES_ACTION = "F1";

const CARREGAR_CREDITOS_DEVOLUCOES_ACTION = "F12";

const ESC_ACTION = "Escape";

const FinalizarVenda = ({
  irParaTelaInit,
  irParaTelaFrentedeCaixa,
  getSessionId,
}) => {
  const classes = useStyles();
  const {
    app: {
      meiosPagamento,
      contasPixADistancia,
      modoOffline,
      consultarPrecosPermissao,
      tipoCaixa,
      tipoPagamentoCartaoCreditoPermissao,
      tipoPagamentoCartaoDebitoPermissao,
      tipoPagamentoDevolucaoPermissao,
      tipoPagamentoDinheiroPermissao,
      tipoPagamentoPixDistanciaPermissao,
      tipoPagamentoPixQrcodePermissao,
      tipoPagamentoVoucherPermissao,
      tipoPagamentoCreditoFidelidadePermissao,
      nomeCaixa,
      IdTerminalSitef,
      usar_tef,
      usar_nova_impressao,
      usar_biometria,
      valor_venda_sem_taxa_sistema_fidelidade,
      valor_venda_com_taxa_sistema_fidelidade,
      interfaceSitef
    },
    openConsultorPrecos,
  } = useContext(AppContext);
  const { venda, dispatch } = useContext(VendaContext);
  const {
    cliente,
    parcelas,
    isEmPartes,
    itensExcluidos,
    cpf,
    uuid,
    idEdit,
    cnpj,
    tipoNota,
    revenda,
    CupomFiscal,
    DataFiscal,
  } = venda;
  const refSidebarInputs = useRef(null);
  const refDialogoSenha = useRef(null);
  const refDialogoConsultorPrecos = useRef(null);

  const refDialogoDeletar = useRef(null);
  const refDialogoConfirmacao = useRef(null);
  const refDialogoLiberarParcela = useRef(null);
  const refDialogoVerQrcode = useRef(null);
  const refDialogoDeletarItem = useRef(null);

  const refDialogoAutorizacaoComQrcode2 = useRef(null);

  const refDialogoCarregarCreditoDevolucao = useRef(null);

  const refDialogoComunicacaoSitef = useRef(null);

  const refDialogoStatusImpressao = useRef(null)

  const [podeParcelaDinheiro, setPodeParcelaDinheiro] = useState(true);

  const refRespondeuPerguntaDinheiro = useRef(false)

  const refDialogoResetarPagamentos = useRef(null)

  const [cont, setCont] = useState(1)

  const {
    resto,
    podeEncerrarTransacao,
    hasPagamentoDinheiro,
    totalParcelas,
    handleFinalizarVenda,
    handleNewItem,
    getPodeUsarParcela,
    hasPagamentoNaoPadrao,
    enqueueSnackbar,
    podeFecharVenda,
    descontoUsadoCliente,
    descontoDisponivelCliente,
    totalAVistaCalculado,
    totalAVistaObrigatorio,
    ehZero,
    hasDinheiroEUnicoPagamento
  } = useParcelas(
    parcelas,
    venda.itens,
    cliente,
    venda.subTotal,
    getSessionId(),
    updateParcela,
    irParaTelaInit,
    isEmPartes,
    itensExcluidos,
    cpf,
    uuid,
    modoOffline,
    idEdit,
    cnpj,
    tipoNota,
    interfaceSitef,
    CupomFiscal,
    DataFiscal,
    abrirDialogoStatusImpressao,
    fecharDialogoStatusImpressao,
    IdTerminalSitef,
    usar_tef,
    usar_nova_impressao,
    valor_venda_sem_taxa_sistema_fidelidade,
    valor_venda_com_taxa_sistema_fidelidade,
    revenda
  );

  function abrirDialogoStatusImpressao(titulo, corpo, conteudoPontos = null, onFechar = null) {
    if(refDialogoStatusImpressao.current) {
      refDialogoStatusImpressao.current.handleOpen(titulo, corpo, conteudoPontos, onFechar)
    }
  }

  function fecharDialogoStatusImpressao() {
    if(refDialogoStatusImpressao.current) {
      refDialogoStatusImpressao.current.handleFechar()
    }
  }

  useEffect(() => {
    if(usar_tef) {
      if (cpf) {
        interfaceSitef.setCpf(cpf);
      }
    }
  }, [cpf]);

  useEffect(() => {
    if (refSidebarInputs.current) refSidebarInputs.current.focus();
  }, []);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if(parcelas.length === 0) perguntaPagamentoDinheiro()
      else {
        refRespondeuPerguntaDinheiro.current = true
        setCont(cont+1)
        setPodeParcelaDinheiro(false)
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [])

  useEffect(() => {
    const erroDistribuicao = hasDinheiroEUnicoPagamento
      ? !podeEncerrarTransacao
      //: resto < -0.05 || resto > 0.05;
      : !ehZero(resto)

      if (!erroDistribuicao) {
        handleFinalizarVenda()
      }
  }, [parcelas.length])

  function updateParcela(body) {
    dispatch({
      type: "ADD_PARCELA",
      parcela: body,
    });
  }

  useEffect(() => {
    if (venda.itens.length <= 0) irParaTelaFrentedeCaixa();
  }, [venda.itens]);

  const colorHeader = modoOffline ? SECONDARY_COLOR_OFFLINE : SECONDARY_COLOR;

  function getIndiceSitef(indices) {
    const parcelasNew = [];
    for (let i = 0; i < indices.length; i++) {
      const el = parcelas.find((par) => par.uidd === indices[i]);
      if (el) {
        if (el.sitef) {
          const n = el.sitef["161"];
          if (n) {
            parcelasNew.push(n);
          }
        }
      }
    }

    return parcelasNew;
  }

  async function getHoraFiscal() {
    try {
      const response = await api.get("/gerar-hora-fiscal-sitef");
      return response.data.hora;
    } catch (e) {
      return null;
    }
  }

  function formatarXXX(numero) {
    return String(numero).padStart(3, '0');
  }

  function isTransacaoTef(parcelas) {
    const TIPOS_TEF = new Set([3, 4, 5]);
    let count = 0;

    for (const p of parcelas) {
      if (TIPOS_TEF.has(p.tipo_pagamento.id)) {
        count++;
        break;
      }
    }

    const temMultiplosTEF = count > 0;

    return temMultiplosTEF;
  }

    async function getDadosFiscaisSitef() {
      try {
        const data = await api.get("/gerar-cumpom-fiscal-sitef");
        return {
          CupomFiscal: data.data.cupom,
          DataFiscal: data.data.data,
          HoraFiscal: data.data.hora,
        }
      } catch (e) {
        enqueueSnackbar("INTERNET: ERRO AO GERAR DADOS FISCAIS", {
          variant: "error",
        });
      }
    }

  async function resetarFormasDePagamento() {
    try {
      const { HoraFiscal, ...rest } = await getDadosFiscaisSitef();

      if (isTransacaoTef(parcelas) && usar_tef) {

        const dados = await interfaceSitef.finishTransaction({
          confirma: 0,
          cupomFiscal: CupomFiscal,
          dataFiscal: DataFiscal,
          horaFiscal: HoraFiscal,
        });

        if (dados.status) {
          dispatch({
            type: "RESETAR_PAGAMENTOS",
            CupomFiscal: rest.CupomFiscal,
            DataFiscal: rest.DataFiscal,
          });
        } else {
          enqueueSnackbar(dados.message, {
            variant: "error",
          });
        }
      } else {
          dispatch({
            type: "RESETAR_PAGAMENTOS",
            CupomFiscal: rest.CupomFiscal,
            DataFiscal: rest.DataFiscal,
          });
      }
    } catch(e) {
      enqueueSnackbar(e ? e.toString() : 'Erro ao deletar as transações', {
        variant: "error",
      });
    } finally {
      if (refSidebarInputs.current) refSidebarInputs.current.focus();
    }
  }

  async function removeItens(indices) {
    let indicesExcluir = []

    if(usar_tef) {
      const indicesSitef = getIndiceSitef(indices);

      const horaFiscal = await getHoraFiscal();

      if (!horaFiscal) {
        return;
      }

      /* for (let i = 0; i < indicesSitef.length; i++) {
        const dados = await interfaceSitef.finishTransaction({
          confirma: 0,
          cupomFiscal: CupomFiscal,
          dataFiscal: DataFiscal,
          horaFiscal: horaFiscal,
          trnAdditionalParameters: `{NumeroPagamentoCupom=${indicesSitef[i]};}`,
        });

        if (dados.status) {
          enqueueSnackbar("Parcela Excluida com sucesso!", {
            variant: "success",
          });

          indicesExcluir.push()
        } else {
          enqueueSnackbar("Erro ao excluir parcela!", {
            variant: "error",
          });
        }
      } */

        for (let i = 0; i < indices.length; i++) {
          const el = parcelas.find((par) => par.uidd === indices[i]);
          if (el) {
            if (el.sitef) {
              const n = el.sitef["161"];
              if (n) {
                const dados = await interfaceSitef.finishTransaction({
                  confirma: 0,
                  cupomFiscal: CupomFiscal,
                  dataFiscal: DataFiscal,
                  horaFiscal: horaFiscal,
                  trnAdditionalParameters: `{NumeroPagamentoCupom=${n};}`,
                });

                 if (dados.status) {
                  enqueueSnackbar("Parcela Excluida com sucesso!", {
                    variant: "success",
                  });

                  indicesExcluir.push(indices[i])
                } else {
                  enqueueSnackbar("Erro ao excluir parcela!", {
                    variant: "error",
                  });
                }
              } 
            } else {
              indicesExcluir.push(indices[i])
            }
          }
        }
    } else {
      indicesExcluir = [...indices]
    }

    dispatch({ type: "REMOVE_PARCELA", indices: indicesExcluir });
  }

  function getOpenDialogoComunicacaoSitef() {
    let podeVoltar = true;
    if (refDialogoComunicacaoSitef) {
      if (refDialogoComunicacaoSitef.current) {
        if (refDialogoComunicacaoSitef.current.getOpen) {
          if (refDialogoComunicacaoSitef.current.getOpen()) {
            podeVoltar = false;
          }
        }
      }
    }

    return podeVoltar;
  }

  function handleActions(action) {
    if (getOpenDialogoComunicacaoSitef()) {
      switch (action) {
        case VOLTAR_ACTION: {
          irParaTelaFrentedeCaixa();
          break;
        }
        case FINALIZAR_ACTION:
          if (podeFecharVenda) {
            openConfirmacao();
          }
          break;
        /* case DELETAR_ITEM_ACTION:
          if (parcelas.length > 0) {
            if (refDialogoDeletarItem.current) {
              refDialogoDeletarItem.current.handleOpen();
            }
          }
          break; */
        case DELETAR_ITEM_ACTION:
          if (parcelas.length > 0) {
            if (refDialogoResetarPagamentos.current) {
              refDialogoResetarPagamentos.current.handleOpen();
            }
           
          }
          break;
        case CONSULTOR_PRECOS_ACTION:
          if (consultarPrecosPermissao) {
            if (refDialogoConsultorPrecos.current) {
              refDialogoConsultorPrecos.current.handleOpen();
            }
          }
          break;
        case VENDA_EM_PARTES_ACTION:
          if (refDialogoAutorizacaoComQrcode2.current) {
            refDialogoAutorizacaoComQrcode2.current.handleOpen();
          }
          break;
        case ESC_ACTION:
          irParaTelaFrentedeCaixa();
          break;
        case CARREGAR_CREDITOS_DEVOLUCOES_ACTION:
          if (cliente) {
            if (cliente.id !== 1) {
              if (tipoPagamentoDevolucaoPermissao) {
                if (refDialogoCarregarCreditoDevolucao.current) {
                  refDialogoCarregarCreditoDevolucao.current.handleOpen();
                }
              }
            } else {
              enqueueSnackbar("O cliente anonimo não pode usar devolução!", {
                variant: "error",
              });
            }
          } else {
            enqueueSnackbar("É necessário especificar o cliente!", {
              variant: "error",
            });
          }
          break;
        default:
          break;
      }
    }
  }

  function changeIsInPartes() {
    dispatch({ type: "CHANGE_IS_EM_PARTES" });
  }

  function handleConfirma(codigo) {
    switch (codigo) {
      case 0:
        handleFinalizarVenda();
        break;
      case 1: {
        setPodeParcelaDinheiro(true)
        refRespondeuPerguntaDinheiro.current = true
        setCont(cont+1)
        break;
      }
      default:
        break;
    }
  }

  function openConfirmacao() {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        "Fechamento da venda",
        "Tem certeza que deseja finalizar a venda!",
        0
      );
    }
  }

  function perguntaPagamentoDinheiro() {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        "Haverá pagamento em dinheiro?",
        "Haverá pagamento em dinheiro?!",
        1,
        'Não',
        'Sim'
      );
    }
  }

  function getLabelsAtalhos() {
    const labelsAtalhos = [];

    labelsAtalhos.push({ atalho: VENDA_EM_PARTES_ACTION, label: "Tipo Venda" });
    labelsAtalhos.push({
      atalho: DELETAR_ITEM_ACTION,
      //label: "Remover parcela",
      label: 'Resetar Pagamentos',
      status: parcelas.length > 0,
    });
    if (consultarPrecosPermissao)
      labelsAtalhos.push({
        atalho: CONSULTOR_PRECOS_ACTION,
        label: "Cons. Preço",
      });
    labelsAtalhos.push({ atalho: VOLTAR_ACTION, label: "Voltar" });
    labelsAtalhos.push({
      atalho: FINALIZAR_ACTION,
      label: "Concluir",
      status:
        podeFecharVenda &&
        !(hasDinheiroEUnicoPagamento
          ? !podeEncerrarTransacao
          //: resto < -0.05 || resto > 0.05),
          : !ehZero(resto)),
      class: hasDinheiroEUnicoPagamento
        ? !podeEncerrarTransacao
          ? ""
          : "btnImprimir"
        //: resto < -0.05 || resto > 0.05
        : !ehZero(resto)
        ? ""
        : "btnImprimir",
    });
    if (tipoPagamentoDevolucaoPermissao)
      labelsAtalhos.push({
        atalho: CARREGAR_CREDITOS_DEVOLUCOES_ACTION,
        label: "Car. Descon.",
      });

    if (labelsAtalhos.length <= 4) {
      return [labelsAtalhos, []];
    }
    return [labelsAtalhos.slice(0, 4), labelsAtalhos.slice(4)];
  }

  function getTipoPagamentoDevolucao() {
    const devolucaoOption = meiosPagamento.find((item) => item.id === 9);
    return devolucaoOption;
  }

  function handleCarregarCreditoDevolucoes(dados) {
    const tipo_pagamento = getTipoPagamentoDevolucao();
    if (tipo_pagamento) {
      const dadosFormatados = [];
      for (let i = 0; i < dados.length; i++) {
        dadosFormatados.push({
          data_pagamento: new Date(),
          tipo_pagamento,
          valor: dados[i].valor,
          uidd: `${tipo_pagamento.nome}${parcelas.length}`,
          troco: 0,
          valor_recebido: 0,
          idIndicadorChange: -1,
          autorizador_id: null,
          credito_devolucao_venda_id: dados[i].id,
        });
      }
      dispatch({
        type: "ADD_PARCELAS_DEVOLUCAO",
        parcelas: dadosFormatados,
      });
    }
  }

  function isTransacaoNormalTef(parcelas, parcela) {
    const TIPOS_TEF = new Set([3, 4, 5]);
    const temTEF = parcelas.some(p =>
      TIPOS_TEF.has(p.tipo_pagamento.id)
    );
    if(temTEF) return false;
    const resto2 = resto - parcela.valor;
    //const erroDistribuicao = resto2 < -0.05 || resto2 > 0.05;
    const erroDistribuicao = !ehZero(resto2)
    if(erroDistribuicao) return false;
    return true
  }

  return (
    <>
      <Box padding="10px" className={classes.header}>
        <Box
          display="flex"
          css={{
            backgroundColor: "transparent",
            opacity: "0.75",
            height: "100%",
            //padding: "0px 10px",
            flexDirection: "column",
          }}
        >
          <Box display="flex" alignItems="center" flex={1}>
            {cliente && (
              <Box
                flex={1}
                style={{
                  marginLeft: "10px",
                  borderRadius: "12px",
                  border: `2px solid ${/* cliente.is_fidelidade */ false ? '#00c853' : '#546e7a'}`,
                  boxShadow: /* cliente.is_fidelidade */ false
                    ? '0 3px 14px rgba(0, 200, 83, 0.28)'
                    : '0 2px 10px rgba(0,0,0,0.12)',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  backgroundColor: 'white',
                  //opacity: "0.75",
                }}
              >
                {/* Topo colorido: nome do cliente + badge de fidelidade */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  style={{
                    background: /* cliente.is_fidelidade */ false
                      ? 'linear-gradient(135deg, #00c853 0%, #69f0ae 100%)'
                      : `linear-gradient(135deg, #546e7a 0%, #90a4ae 100%)`,
                    padding: '6px 14px',
                    flexShrink: 0,
                  }}
                >
                  <Box display="flex" alignItems="center" style={{ gap: '8px', minWidth: 0 }}>
                    <span style={{ fontSize: '18px', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.2))', flexShrink: 0 }}>
                      {/* cliente.is_fidelidade */ false ? '⭐' : '👤'}
                    </span>
                    <Typography
                      style={{
                        color: 'white',
                        fontWeight: 700,
                        fontSize: '15px',
                        textShadow: '0 1px 3px rgba(0,0,0,0.2)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {cliente.nome}
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      backgroundColor: 'rgba(255,255,255,0.22)',
                      border: '1px solid rgba(255,255,255,0.45)',
                      borderRadius: '8px',
                      padding: '3px 12px',
                      flexShrink: 0,
                      marginLeft: '10px',
                    }}
                  >
                    <Typography
                      variant="caption"
                      style={{
                        color: 'white',
                        fontWeight: 700,
                        fontSize: '12px',
                        letterSpacing: '0.3px',
                      }}
                    >
                      {/* cliente.is_fidelidade */ false ? 'Fidelidade ⭐' : 'Cliente Padrão'}
                    </Typography>
                  </Box>
                </Box>

                {/* Dados do cliente em duas colunas */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  style={{ padding: '4px 14px', flex: 1 }}
                >
                  <Box display="flex" flexDirection="column" flex={1}>
                    <Box display="flex" flex={1} alignItems="center" style={{ fontSize: '13px', fontWeight: 'bold', gap: '6px', minWidth: 0 }}>
                      <span style={{ color: colorHeader, whiteSpace: 'nowrap', flexShrink: 0 }}>Razão Social:</span>
                      <span className={classes.textOverflow}>{cliente.razao_social}</span>
                    </Box>
                    <Box display="flex" flex={1} alignItems="center" style={{ fontSize: '13px', fontWeight: 'bold', gap: '6px', minWidth: 0 }}>
                      <span style={{ color: colorHeader, whiteSpace: 'nowrap', flexShrink: 0 }}>CPF:</span>
                      <span className={classes.textOverflow}>{formatCPF(cliente.cpf)}</span>
                    </Box>
                    <Box display="flex" flex={1} alignItems="center" style={{ fontSize: '13px', fontWeight: 'bold', gap: '6px', minWidth: 0 }}>
                      <span style={{ color: colorHeader, whiteSpace: 'nowrap', flexShrink: 0 }}>CNPJ:</span>
                      <span className={classes.textOverflow}>{formatCNPJ(cliente.cnpj)}</span>
                    </Box>
                    <Box display="flex" flex={1} alignItems="center" style={{ fontSize: '13px', fontWeight: 'bold', gap: '6px', minWidth: 0 }}>
                      <span style={{ color: colorHeader, whiteSpace: 'nowrap', flexShrink: 0 }}>Categoria:</span>
                      <span className={classes.textOverflow}>{cliente.categoria ? `${cliente.categoria.nome}` : ""}</span>
                    </Box>
                  </Box>
                  <Box display="flex" flexDirection="column" flex={1} style={{ marginLeft: '14px' }}>
                    <Box display="flex" flex={1} alignItems="center" style={{ fontSize: '13px', fontWeight: 'bold', gap: '6px', minWidth: 0 }}>
                      <span style={{ color: colorHeader, whiteSpace: 'nowrap', flexShrink: 0 }}>Nome Fantasia:</span>
                      <span className={classes.textOverflow}>{cliente.nome_fantasia}</span>
                    </Box>
                    <Box display="flex" flex={1} alignItems="center" style={{ fontSize: '13px', fontWeight: 'bold', gap: '6px', minWidth: 0 }}>
                      <span style={{ color: colorHeader, whiteSpace: 'nowrap', flexShrink: 0 }}>Cidade:</span>
                      <span className={classes.textOverflow}>
                        {cliente.cidade ? `${cliente.cidade.nome} - ${cliente.cidade.estado.sigla}` : ""}
                      </span>
                    </Box>
                    <Box display="flex" flex={1} alignItems="center" style={{ fontSize: '13px', fontWeight: 'bold', gap: '6px', minWidth: 0 }}>
                      <span style={{ color: colorHeader, whiteSpace: 'nowrap', flexShrink: 0 }}>Telefone:</span>
                      <span className={classes.textOverflow}>{formatTelefone(cliente.telefone)}</span>
                    </Box>
                    <Box display="flex" flex={1} alignItems="center" style={{ fontSize: '13px', fontWeight: 'bold', gap: '6px', minWidth: 0 }}></Box>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        padding="10px"
        className={classes.body}
      >
        <Box
          flex={1.5}
          display="flex"
          flexDirection="column"
          overflow="auto"
          justifyContent="space-between"
        >
          <Box>
            <LabelCaixa
              descontoDisponivelCliente={descontoDisponivelCliente}
              descontoUsadoCliente={descontoUsadoCliente}
              cliente={cliente}
              tipoCaixa={tipoCaixa}
              isEmPartes={isEmPartes}
              nomeCaixa={nomeCaixa}
              tipoNota={tipoNota}
            />
            <LabelTotalParcelas total={totalParcelas} totalRestante={resto} />
            {totalAVistaObrigatorio > 0 ? (
              <LabelTotalParcelasAVista
                totalAVistaCalculado={totalAVistaCalculado}
                totalAVistaObrigatorio={totalAVistaObrigatorio}
              />
            ) : null}
            <Box mt="15px">
              <LabelSubtotal valor={venda.subTotal} />
            </Box>
            {/*cliente && cliente.is_fidelidade && (() => {
              const hasLiberacao = venda.itens && venda.itens.some(
                (item) => item.tipo_oferta === TIPO_OFERTA_PRODUTO_LIBERACAO
              );
              const pontos = hasLiberacao
                ? 0
                : calcularPontosFidelidade({
                    itens: venda.itens,
                    parcelas,
                    valorSemTaxa: valor_venda_sem_taxa_sistema_fidelidade,
                    valorComTaxa: valor_venda_com_taxa_sistema_fidelidade,
                    TIPO_LIBERACAO: TIPO_OFERTA_PRODUTO_LIBERACAO,
                  });
              const semPagamento = parcelas.length === 0;
              if(hasLiberacao) return null
              return (
                <Box mt="8px">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      borderRadius: '10px',
                      padding: '6px 12px',
                      background: hasLiberacao
                        ? 'linear-gradient(135deg, #b0bec5 0%, #cfd8dc 100%)'
                        : pontos > 0
                        ? 'linear-gradient(135deg, #f9a825 0%, #ffd54f 100%)'
                        : 'linear-gradient(135deg, #eeeeee 0%, #e0e0e0 100%)',
                      boxShadow: pontos > 0 && !hasLiberacao
                        ? '0 2px 8px rgba(249,168,37,0.35)'
                        : 'none',
                    }}
                  >
                    <Typography
                      style={{
                        color: hasLiberacao ? '#607d8b' : pontos > 0 ? '#5d4037' : '#757575',
                        fontWeight: 700,
                        fontSize: '12px',
                      }}
                    >
                      ⭐ Pontos da venda
                    </Typography>
                    <Typography
                      style={{
                        color: hasLiberacao ? '#607d8b' : pontos > 0 ? '#5d4037' : '#757575',
                        fontWeight: 800,
                        fontSize: '15px',
                      }}
                    >
                      {semPagamento && !hasLiberacao ? '— pts' : `+${pontos} pts`}
                    </Typography>
                  </div>
                  {hasLiberacao && (
                    <Typography
                      style={{ fontSize: '10px', color: '#90a4ae', textAlign: 'center', marginTop: '2px' }}
                    >
                      Preço liberado anula pontos
                    </Typography>
                  )}
                </Box>
              );
            })()*/}
          </Box>
          <LabelTeclasAtalho grid={getLabelsAtalhos()} />
        </Box>
        <Box padding="0 10px" flex={4}>
          <Tabela
            rows={toStringParcela(parcelas)}
            headCells={[
              {
                field: "numeroItem",
                label: "Código",
              },
              {
                field: "tipo_pagamento",
                label: "Meio de Pagamento",
              },
              {
                field: "valor",
                right: true,
                label: "Valor",
              },
              {
                field: "data_pagamento",
                right: true,
                label: "Data de Pagamento",
              },
              {
                field: "valor_recebido",
                right: true,
                label: "Valor Recebido",
              },
              {
                field: "troco",
                right: true,
                label: "Troco",
              },
              {
                field: "conta",
                right: true,
                label: "Conta",
              },
            ]}
          />
        </Box>
        <Box flex={1.5} display="flex" flexDirection="column">
          <FormParcela
            podeParcelaDinheiro={podeParcelaDinheiro}
            handleKey={(keyCode, keyName) => {
              handleActions(keyName);
            }}
            ref={refSidebarInputs}
            handleNewItem={(data) => {
              switch (data.tipo_pagamento.id) {
                case 1: {
                  handleNewItem(data);
                  break;
                }
                case 2: {
                  handleNewItem(data);
                  break;
                }
                case 3: {
                  // crédito
                  if(usar_tef) {
                    if (refDialogoComunicacaoSitef.current) {
                      //refDialogoComunicacaoSitef.current.vendaCredito(data, isTransacaoNormalTef(parcelas, data));
                      refDialogoComunicacaoSitef.current.vendaCredito(data, false);
                    }
                  } else {
                    handleNewItem({ ...data, sitef: null });
                  }
                  break;
                }
                case 4: {
                  // débito
                  if(usar_tef) {
                    if (refDialogoComunicacaoSitef.current) {
                      //refDialogoComunicacaoSitef.current.vendaDebito(data, isTransacaoNormalTef(parcelas, data));
                      refDialogoComunicacaoSitef.current.vendaDebito(data, false);
                    }
                  } else {
                    handleNewItem({ ...data, sitef: null });
                  }
                  break;
                }
                case 5: {
                  // pix qrcode
                  if(usar_tef) {
                    if (refDialogoComunicacaoSitef.current) {
                      //refDialogoComunicacaoSitef.current.vendaPix(data, isTransacaoNormalTef(parcelas, data));
                      refDialogoComunicacaoSitef.current.vendaPix(data, false);
                    }
                  } else {
                    handleNewItem({ ...data, sitef: null });
                  }
                  break;
                }
                case 6: {
                  handleNewItem(data);
                  break;
                }
                case 7: {
                  handleNewItem(data);
                  break;
                }
                case 8: {
                  handleNewItem(data);
                  break;
                }
                case 9: {
                  if (refDialogoLiberarParcela.current) {
                    refDialogoLiberarParcela.current.handleOpen(1, data);
                  }
                  break;
                }
                case 10: {
                  if (refDialogoLiberarParcela.current) {
                    refDialogoLiberarParcela.current.handleOpen(1, data);
                  }
                  break;
                }
                case 11: {
                  handleNewItem(data);
                  break;
                }
                default:
                  handleNewItem(data);
                  break;
              }
            }}
            resto={resto}
            validateParcela={getPodeUsarParcela}
            hasPagamentoDinheiro={hasPagamentoDinheiro}
            hasPagamentoNaoPadrao={hasPagamentoNaoPadrao}
            parcelas={parcelas}
            cliente={cliente}
            descontoDisponivelCliente={descontoDisponivelCliente}
            descontoUsadoCliente={descontoUsadoCliente}
            tipoPagamentoCartaoCreditoPermissao={
              tipoPagamentoCartaoCreditoPermissao
            }
            tipoPagamentoCartaoDebitoPermissao={
              tipoPagamentoCartaoDebitoPermissao
            }
            tipoPagamentoDevolucaoPermissao={false}
            tipoPagamentoDinheiroPermissao={tipoPagamentoDinheiroPermissao}
            tipoPagamentoPixDistanciaPermissao={
              tipoPagamentoPixDistanciaPermissao
            }
            tipoPagamentoPixQrcodePermissao={tipoPagamentoPixQrcodePermissao}
            tipoPagamentoVoucherPermissao={tipoPagamentoVoucherPermissao}
            tipoPagamentoCreditoFidelidadePermissao={
              tipoPagamentoCreditoFidelidadePermissao
            }
            meioPagamentosOptions={meiosPagamento}
            totalAVistaCalculado={totalAVistaCalculado}
            totalAVistaObrigatorio={totalAVistaObrigatorio}
            contasPixADistanciaOptions={contasPixADistancia}
            respondeuPerguntaDinheiro={refRespondeuPerguntaDinheiro.current}
            subTotal={venda.subTotal}
          />
        </Box>
      </Box>
      <KeyboardEventHandler
        handleKeys={[
          VOLTAR_ACTION,
          FINALIZAR_ACTION,
          DELETAR_ITEM_ACTION,
          VENDA_EM_PARTES_ACTION,
        ]}
        onKeyEvent={(key) => handleActions(key)}
      />
      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
        isInput
        openConsultorPrecos={openConsultorPrecos}
        labelBotao1={ "Sim" }
        labelBotao2={ "Não" }
        enableEsc={false}
        handleClose2={(codigo) => {
          switch (codigo) {
            case 0:
              break;
            case 1: {
              setPodeParcelaDinheiro(false)
              refRespondeuPerguntaDinheiro.current = true
              setCont(cont+1)
              break;
            }
            default:
              break;
          }
        }}
      />
      <DialogoSenha
        ref={refDialogoSenha}
        handleClose={() => {}}
        enqueueSnackbar={enqueueSnackbar}
        handleCancelar={() => {}}
        handleSalvar={() => {
          irParaTelaFrentedeCaixa();
        }}
        mensagemSucesso="Venda liberada para edição"
        title="Autorização voltar à tela de itens!"
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoDeletarComSenha
        ref={refDialogoDeletar}
        itens={parcelas}
        enqueueSnackbar={enqueueSnackbar}
        handleCancelar={() => {}}
        handleSalvar={(numeroItem) => {
          removeItens([parcelas[numeroItem - 1].uidd]);
        }}
        title="Autorização para remover parcela!"
        mensagemRemovido="Parcela removida com sucesso!"
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoConsultorPrecos
        ref={refDialogoConsultorPrecos}
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoAutorizacaoComQrcode
        ref={refDialogoLiberarParcela}
        handleClose={() => {}}
        enqueueSnackbar={enqueueSnackbar}
        handleSalvar={(user_id, data) => {
          handleNewItem(data, user_id);
        }}
        mensagemSucesso="Confirmação do Pix a Distância com sucesso!"
        title="Autorização Pix a Distância!"
        openConsultorPrecos={openConsultorPrecos}
        usar_biometria={usar_biometria}
      />
      <DialogoDeletarItem
        ref={refDialogoDeletarItem}
        enqueueSnackbar={enqueueSnackbar}
        handleCancelar={() => {}}
        handleSalvar={(codigo) => {
          const position = parseInt(codigo, 10) - 1;
          if (position <= parcelas.length - 1) {
            removeItens([parcelas[position].uidd]);
            enqueueSnackbar("Parcela removida com sucesso!", {
              variant: "success",
            });
          } else {
            enqueueSnackbar("Não existe uma parcela com este código!", {
              variant: "error",
            });
          }
        }}
        title="Remover Item!"
        mensagemRemovido="Item Removido com Sucesso!"
        titleAutorizacao="Autorizar remoção de item"
        mensagemRemovidoAutorizacao="Autorizada a remoção do item!"
        openConsultorPrecos={openConsultorPrecos}
        usar_biometria={usar_biometria}
      />
      <DialogoVerQRCode
        ref={refDialogoVerQrcode}
        handleClose={() => {
          if (refSidebarInputs.current) refSidebarInputs.current.focus();
        }}
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoAutorizacaoQrcode2
        ref={refDialogoAutorizacaoComQrcode2}
        handleSalvar={() => {
          changeIsInPartes();
        }}
        enqueueSnackbar={enqueueSnackbar}
        mensagemSucesso={
          isEmPartes
            ? "Venda alterada para Venda Comum"
            : "Venda alterada para Venda em partes"
        }
        title={
          isEmPartes ? "Mudar para venda comum" : "Mudar para venda em partes"
        }
        openConsultorPrecos={openConsultorPrecos}
        usar_biometria={usar_biometria}
      />
      <DialogoCarregarCreditoDevolucao
        ref={refDialogoCarregarCreditoDevolucao}
        handleCarregarCreditoDevolucoes={handleCarregarCreditoDevolucoes}
        cliente={cliente}
        openConsultorPrecos={openConsultorPrecos}
      />
      <DialogoComunicacaoSitef
        ref={refDialogoComunicacaoSitef}
        interfaceSitef={interfaceSitef}
        handleResposta={(item, message, data, isReimpressao) => {
          if (!isReimpressao) {
            if (item) {
              handleNewItem({ ...item, sitef: data });
              if (data) {
                if(IS_IMPRIMIR_COMPROVANTE_TEF_POS_REGISTRO_TRANSACAO) imprimirComprovanteTef(data);
              }
            } else {
              enqueueSnackbar(message, {
                variant: "error",
              });
            }
          } else {
            if (data) {
              imprimirComprovanteTef(data);
            }
          }
        }}
        CupomFiscal={CupomFiscal}
        DataFiscal={DataFiscal}
      />
      <DialogoStatusImpressao
        ref={refDialogoStatusImpressao}
      />
      <DialogoResetarPagamentos
        ref={refDialogoResetarPagamentos}
        enqueueSnackbar={enqueueSnackbar}
        handleCancelar={() => {}}
        handleSalvar={(codigo) => {
         resetarFormasDePagamento()
        }}
        title="Estornar Pagamentos"
        mensagemRemovido="Solicitação Feita com Sucesso!"
        titleAutorizacao="Autorizar Estorno dos Pagamentos"
        mensagemRemovidoAutorizacao="Autorizado o estorno dos pagamentos!"
        openConsultorPrecos={openConsultorPrecos}
        usar_biometria={usar_biometria}
        content= 'Deseja realmente estornar todos os pagamentos?'
      />
    </>
  );
};

export default FinalizarVenda;
